// section-coming-soon.js
// The stage should fill whatever viewport is left below the header. The theme
// exposes no header-height variable and the header stack varies (announcement
// bar on/off, one or two nav rows, mobile), so measure it instead of guessing
// and publish the result as --cs-offset for the CSS to size against.
(function () {
  const stages = document.querySelectorAll('.coming-soon');
  if (!stages.length) return;

  function measure() {
    stages.forEach((stage) => {
      // Distance from the top of the document to the stage == everything
      // stacked above it. Works whether or not the header is sticky.
      const top = stage.getBoundingClientRect().top + window.scrollY;
      stage.style.setProperty('--cs-offset', Math.max(0, Math.round(top)) + 'px');
    });
  }

  measure();

  // Re-measure once webfonts land, since they reflow the header.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

  let frame;
  addEventListener('resize', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measure);
  }, { passive: true });

  // The announcement bar and header can change height after their own scripts
  // run; watch them rather than polling.
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(() => measure());
    document.querySelectorAll('.shopify-section-group-header-group, .announcement-bar, .header')
      .forEach((el) => observer.observe(el));
  }
})();
